module.exports = __webpack_public_path__ + "static/media/Processexplained.30768078.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/img/medibank/Processexplained.mp4
// module id = 209
// module chunks = 0